var _defs, _rect, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _line, _line2, _line3, _line4, _line5, _line6, _polygon11, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCp3CalendarHouseFlipFlopIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.f,.i{fill:none;}.b{fill:#3c3c46;opacity:0.15;}.b,.c,.d,.e,.f,.g,.h{fill-rule:evenodd;}.c{fill:#3ca4ef;}.c,.d,.f,.i{stroke:#3c3c46;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.d,.e{fill:#89d9fb;}.g{fill:#fff;}.h{fill:#ffefe0;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-calendar-house-flip-flop-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "113.79 39.08 35.94 39.08 55.2 110.92 133.04 110.92 113.79 39.08"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "106.18 33.08 28.34 33.08 49.2 110.92 127.04 110.92 106.18 33.08"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "106.18 97.94 28.34 97.94 49.2 110.92 127.04 110.92 106.18 97.94"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "106.18 97.94 28.34 97.94 7.48 110.92 85.32 110.92 106.18 97.94"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "107.18 33.08 29.34 33.08 29.34 110.92 128.04 110.92 107.18 97.94 107.18 33.08"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "28.34 33.08 106.18 33.08 85.32 110.92 7.48 110.92 28.34 33.08"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "28.34 33.08 106.18 33.08 85.32 110.92 7.48 110.92 28.34 33.08"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "24.34 33.08 102.18 33.08 84.8 97.94 6.96 97.94 24.34 33.08"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    points: "63.26 33.08 102.18 33.08 84.8 97.94 45.88 97.94 63.26 33.08"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "29.08 45.26 67.73 45.26 56.88 85.76 18.23 85.76 29.08 45.26"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 72.32,
    y1: 54.66,
    x2: 88.62,
    y2: 54.66
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 70.38,
    y1: 61.89,
    x2: 86.68,
    y2: 61.89
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 68.45,
    y1: 69.12,
    x2: 84.75,
    y2: 69.12
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 66.52,
    y1: 76.35,
    x2: 82.82,
    y2: 76.35
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 74.25,
    y1: 47.43,
    x2: 90.55,
    y2: 47.43
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 64.39,
    y1: 83.58,
    x2: 80.69,
    y2: 83.58
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "24.34 33.08 102.18 33.08 84.8 97.94 6.96 97.94 24.34 33.08"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M32.34,37.08a4,4,0,1,1,4-4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M42.5,37.08a4,4,0,1,1,4-4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M52.66,37.08a4,4,0,1,1,4-4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M62.83,37.08a4,4,0,1,1,4-4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M73,37.08a4,4,0,1,1,4-4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M83.15,37.08a4,4,0,1,1,4-4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M93.31,37.08a4,4,0,1,1,4-4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp3CalendarHouseFlipFlopIcon);
export default __webpack_public_path__ + "static/media/CP3-calendar-house-flip-flop-icon.1f04f890413da8f18c3001d9f2b5e568.svg";
export { ForwardRef as ReactComponent };